export default {
  'menu.welcome': 'Welcome',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.register-result': 'Register Result',
  'menu.dashboard': 'Dashboard',
  'menu.domestic-warehouse': 'Domestic Warehouse',
  'menu.domestic-warehouse.inbound': 'Inbound',
  'menu.domestic-warehouse.product': 'Products',
  'menu.overseas-warehouse': 'Overseas Warehouse',
  'menu.finance': 'Finance',
  'menu.finance.billing': 'Billing',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
  'menu.warehouse-orders': 'Warehouse Orders',
  'menu.ocean-bill': 'Ocean Bill of Lading',
  'menu.online-order': 'Online Orders',
  'menu.cross-border-logistics': 'Cross-border Logistics',
  'menu.one-piece-delivery': 'One-piece Delivery',
  'menu.product-inventory': 'Product Inventory',
  'menu.returns-management': 'Returns Management',
  'menu.settings-management': 'Settings Management',
  'menu.member-profile': 'Member Profile',
  'menu.e-account': 'My E-Account',
  'menu.billing-management': 'Billing Management',
  'menu.fund-records': 'Fund Records',
  'menu.invoice-title': 'Invoice Title',
  'menu.store-authorization': 'Store Authorization',
  'menu.fba-management': 'FBA Direct Orders',
};
